// Runs generated code where it can't reach the app or the network:
//   app ── MessageChannel ──► Web Worker (runtime.js)
//                              inside a hidden <iframe sandbox="allow-scripts">
// The iframe has an opaque origin (no cookies, storage or access to the app)
// and a CSP of default-src 'none' (no network); the worker inherits both.
// The worker keeps endless loops off the UI thread. Each run gets its own
// sandbox; when the run ends (or times out) the iframe is removed, which
// kills the worker and frees its memory.
import { WORKER_SOURCE } from "./runtime";

const READY = "ledgerate-sandbox:ready";
const CONNECT = "ledgerate-sandbox:connect";
const START_TIMEOUT_MS = 10000;

const CSP = "default-src 'none'; script-src 'unsafe-inline' 'unsafe-eval' blob:; worker-src blob:";

// `<` is escaped so the source can't close the <script> tag.
const frameHtml = () => `<!doctype html><meta http-equiv="Content-Security-Policy" content="${CSP}"><script>
var source = ${JSON.stringify(WORKER_SOURCE).replace(/</g, "\\u003c")};
var connected = false;
window.addEventListener("message", function (event) {
  if (connected || event.data !== "${CONNECT}" || !event.ports[0]) return;
  connected = true;
  var worker = new Worker(URL.createObjectURL(new Blob([source], { type: "text/javascript" })));
  worker.postMessage("connect", [event.ports[0]]);
});
parent.postMessage("${READY}", "*");
</script>`;

export class SandboxError extends Error {
  constructor(message, { timeout = false, stepId } = {}) {
    super(message);
    this.name = "SandboxError";
    this.timeout = timeout;
    this.stepId = stepId;
  }
}

// Starts a sandbox and resolves with { port, stop }: `port` talks to the
// sandbox worker (see runtime.js) and can be handed to another worker, so
// table data never passes through the UI thread. `stop` removes the iframe,
// which kills the worker.
export const startSandbox = () => {
  const frame = document.createElement("iframe");
  frame.setAttribute("sandbox", "allow-scripts");
  frame.setAttribute("aria-hidden", "true");
  frame.style.display = "none";
  frame.srcdoc = frameHtml();
  const stop = () => frame.remove();
  const started = new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", onReady);
      stop();
      reject(new SandboxError("The code sandbox didn't start. Reload the page and try again."));
    }, START_TIMEOUT_MS);
    function onReady(event) {
      if (event.source !== frame.contentWindow || event.data !== READY) return;
      window.removeEventListener("message", onReady);
      clearTimeout(timer);
      const channel = new MessageChannel();
      frame.contentWindow.postMessage(CONNECT, "*", [channel.port2]);
      resolve({ port: channel.port1, stop });
    }
    window.addEventListener("message", onReady);
  });
  document.body.appendChild(frame);
  return started;
};
